if (!customElements.get('rqst-header-logo')) {
  customElements.define('rqst-header-logo', class extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('[data-site-header]');
      if (!this.header || this.header.classList.contains('js__header__clone')) return;
      this.logo = this.closest('[data-logo]');
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.observer = new ResizeObserver(this.scheduleMeasure);
      this.observer.observe(this.logo);
      this.querySelectorAll('img').forEach(image => image.addEventListener('load', this.scheduleMeasure));
      window.addEventListener('resize', this.scheduleMeasure, {passive: true});
      this.scheduleMeasure();
    }

    measure() {
      if (!this.isConnected) return;
      const styles = getComputedStyle(this.logo);
      const height = Math.max(60, Math.ceil(this.logo.getBoundingClientRect().height + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom)));
      if (height === this.height) return;
      this.height = height;
      this.header.dataset.height = String(height);
      const root = document.documentElement;
      root.style.setProperty('--header-height', `${height}px`);
      root.style.setProperty('--header-background-height', `${height}px`);
      const stickyHeight = this.header.hasAttribute('data-header-sticky') ? height : 0;
      root.style.setProperty('--header-sticky-height', `${stickyHeight}px`);
      window.stickyHeaderHeight = stickyHeight;
      window.theme?.setVars?.();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      window.removeEventListener('resize', this.scheduleMeasure);
      this.querySelectorAll('img').forEach(image => image.removeEventListener('load', this.scheduleMeasure));
    }
  });
}
